class EndpointFunctions {
  static fetchData = async ({ axiosPrivate, endpointURL, httpParams }) => {
    let response;
    if (httpParams != null) {
      response = await axiosPrivate.get(endpointURL, {
        params: httpParams,
      });
    } else {
      response = await axiosPrivate.get(endpointURL);
    }
    console.log("---RESPONSE---", response);
    return response;
  };

  static postData = async ({
    axiosPrivate,
    endpointURL,
    formData,
    requestBody,
    isMultiPart,
  }) => {
    let response;
    if (isMultiPart) {
      response = await axiosPrivate.post(endpointURL, formData, {
        multiPart: isMultiPart,
      });
    } else {
      response = await axiosPrivate.post(endpointURL, requestBody);
    }
    console.log("---RESPONSE---", response);
    return response;
  };

  static putData = async ({
    axiosPrivate,
    endpointURL,
    data,
    formData,
    params,
    isMultiPart,
  }) => {
    let response;
    if (isMultiPart) {
      response = await axiosPrivate.put(
        endpointURL,
        formData,
        {
          multiPart: isMultiPart,
        },
        {
          params: params,
        }
      );
    } else {
      response = await axiosPrivate.put(endpointURL, data, {
        params: params,
      });
    }
    console.log("---RESPONSE---", response);
    return response;
  };

  static deleteRecord = async ({ axiosPrivate, endpointURL, recordId }) => {
    const requestBody = {
      id: recordId,
    };
    console.log("---REQUEST BODY---", requestBody);

    const response = await axiosPrivate.delete(
      `${endpointURL}/${recordId}`,
      requestBody
    );
    console.log("---RESPONSE---", response);
    return response;
  };

  static deleteData = async ({ axiosPrivate, endpointURL, requestBody }) => {
    console.log("---REQUEST BODY---", requestBody);

    const response = await axiosPrivate.delete(endpointURL, requestBody);
    console.log("---RESPONSE---", response);
    return response;
  };
  static deleteWithoutData = async ({ axiosPrivate, endpointURL }) => {
    const response = await axiosPrivate.delete(endpointURL);
    // console.log("---RESPONSE---", response);
    return response;
  };
}

export default EndpointFunctions;
